










































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Informes extends Vue {
  private win = window;
  private base = window.location;
  private menu = "";
  private menuLateral: any = [];
  private nombreWeb: any = "";
  private informes: any = [];

  private documentos: any = [];
  private mounted() {
    document.title =
      "Informes Financieros - Ilustre Municipalidad de Punta Arenas";
    this.setMenu();
    this.getInformes();
  }

  private getInformes() {
    this.$q.loading.show({
      delay: 100 // ms
    });
    this.$axios
      .get("informes")
      .then(res => {
        let base = process.env.VUE_APP_BASE_URL;
        this.informes = res.data.sesion;
        for (let i = 0; i < this.informes.length; i++) {
          if (this.informes[i].informe_anual) {
            for (let j = 0; j < this.informes[i].informe_anual.length; j++) {
              this.informes[i].informe_anual[j].archivo =
                base + this.informes[i].informe_anual[j].archivo;
            }
          }
          if (this.informes[i].informe_trimestral) {
            for (
              let j = 0;
              j < this.informes[i].informe_trimestral.length;
              j++
            ) {
              this.informes[i].informe_trimestral[j].archivo =
                base + this.informes[i].informe_trimestral[j].archivo;
            }
          }
          if (this.informes[i].informe_mensual) {
            for (let j = 0; j < this.informes[i].informe_mensual.length; j++) {
              if (
                this.informes[i].informe_mensual[j].ingreso &&
                this.informes[i].informe_mensual[j].ingreso != ""
              ) {
                this.informes[i].informe_mensual[j].ingreso.archivo =
                  base + this.informes[i].informe_mensual[j].ingreso.archivo;
              }
              if (
                this.informes[i].informe_mensual[j].gastos &&
                this.informes[i].informe_mensual[j].gastos != ""
              ) {
                this.informes[i].informe_mensual[j].gastos.archivo =
                  base + this.informes[i].informe_mensual[j].gastos.archivo;
              }
              if (
                this.informes[i].informe_mensual[j].otros &&
                this.informes[i].informe_mensual[j].otros != ""
              ) {
                this.informes[i].informe_mensual[j].otros.archivo =
                  base + this.informes[i].informe_mensual[j].otros.archivo;
              }
            }
          }
        }
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        this.informes = [];
      });
  }

  private descargarArchivo(url: string) {
    this.win.open(url, "_blank");
    return;
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }

  private async setMenu() {
    const runtimeConfig1 = await fetch(
      "https://admin.puntaarenas.cl/menu.json"
    );
    this.menu = await runtimeConfig1.json();
    for (let i = 0; i < this.menu.length; i++) {
      this.getSubMenu(this.menu[i], "informes-financieros", 1);
    }
  }

  private getSubMenu(element: any, nombre_web: string, profundidad) {
    if (element.nombre_web == nombre_web) {
      return true;
    } else {
      if (element.sub_menu && element.sub_menu.length > 0) {
        for (let j = 0; j < element.sub_menu.length; j++) {
          if (
            this.getSubMenu(element.sub_menu[j], nombre_web, profundidad + 1)
          ) {
            if (profundidad == 2) {
              return true;
            } else {
              this.menuLateral = element.sub_menu;
              this.checkSubMenus();
              return false;
            }
          }
        }
      }
      return false;
    }
  }

  private selectedStyle(item: any) {
    if (
      item.nombre_web == "informes" ||
      "informes-financieros" == item.nombre_web
    ) {
      item.expand = true;
      return " background-color: #02436b !important; color: #f1f1f1 !important;font-family: 'RubikBold' !important;";
    } else {
      let childSelected = false;
      if (item.sub_menu && item.sub_menu.length > 0) {
        for (let i = 0; i < item.sub_menu.length; i++) {
          if (
            item.sub_menu[i].nombre_web == "informes" ||
            item.sub_menu[i].nombre_web == "informes-financieros"
          ) {
            childSelected = true;
          }
        }
        if (childSelected) {
          item.expand = true;
          return " background-color: #02436b !important; color: #f1f1f1 !important;font-family: 'RubikBold' !important;";
        }
      }
      return "";
    }
  }

  private checkSubMenus() {
    for (let i = 0; i < this.menuLateral.length; i++) {
      if (this.menuLateral[i].sub_menu.length > 0) {
        if (
          this.menuLateral[i].tipo == 2 &&
          ("informes" == this.menuLateral[i].nombre_web ||
            "informes-financieros" == this.menuLateral[i].nombre_web)
        ) {
          this.menuLateral[i].expand = true;
        }
      } else {
        this.menuLateral[i].expand = false;
      }
    }
  }

  private toLink(item: any, blank: any) {
    if (item && item != "") {
      if (blank == 1) {
        window.open(item, "_blank");
      } else {
        window.open(item, "_self");
      }
    } else {
      return;
    }
  }

  private irPagina(nombreWeb: any) {
    if (nombreWeb == "contacto") {
      this.routerGo("Contacto");
    } else if (nombreWeb == "concejo-municipal" || nombreWeb == "concejo") {
      this.routerGo("Concejo");
    } else if (
      nombreWeb == "actas-del-concejo" ||
      nombreWeb == "actas-del-concejo-municipal"
    ) {
      this.routerGo("ActasConcejo");
    } else if (
      nombreWeb == "oficinas-y-telefonos-municipales" ||
      nombreWeb == "contactos"
    ) {
      this.routerGo("Telefonos");
    } else if (
      nombreWeb == "organigrama-municipal" ||
      nombreWeb == "organigrama"
    ) {
      this.routerGo("Organigrama");
    } else if (nombreWeb == "cosoc") {
      this.routerGo("Cosoc");
    } else if (nombreWeb == "informes-financieros") {
      this.routerGo("Informes");
    } else if (nombreWeb == "ordenanzas-municipales") {
      this.routerGo("Ordenanzas");
    } else if (nombreWeb == "ofertas-laborales") {
      this.routerGo("OfertasOmil");
    } else {
      if (nombreWeb && nombreWeb != "") {
        if (
          this.$router.currentRoute.name == "Pagina" &&
          this.$router.currentRoute.params.nombre &&
          this.$router.currentRoute.params.nombre == nombreWeb
        ) {
          this.$router.go(0);
        } else {
          if (this.$router.currentRoute.name == "Pagina") {
            if (
              this.$router.currentRoute.params.nombre &&
              this.$router.currentRoute.params.nombre != nombreWeb
            ) {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
              this.$router.go(0);
            } else {
              this.$router
                .push({ name: "Pagina", params: { nombre: nombreWeb } })
                .catch(err => {
                  console.log(err);
                });
            }
          } else {
            this.$router
              .push({ name: "Pagina", params: { nombre: nombreWeb } })
              .catch(err => {
                console.log(err);
              });
          }
        }
      }
    }
  }

  private sendMail(correo: string) {
    window.open("mailto:" + correo);
  }

  private displayLabel(informe: any) {
    if (informe.mes && informe.mes != "") {
      if (informe.mes == "01") {
        let label = "Enero";
        return label;
      } else if (informe.mes == "02") {
        let label = "Febrero";
        return label;
      } else if (informe.mes == "03") {
        let label = "Marzo";
        return label;
      } else if (informe.mes == "04") {
        let label = "Abril";
        return label;
      } else if (informe.mes == "05") {
        let label = "Mayo";
        return label;
      } else if (informe.mes == "06") {
        let label = "Junio";
        return label;
      } else if (informe.mes == "07") {
        let label = "Julio";
        return label;
      } else if (informe.mes == "08") {
        let label = "Agosto";
        return label;
      } else if (informe.mes == "09") {
        let label = "Septiembre";
        return label;
      } else if (informe.mes == "10") {
        let label = "Octumbre";
        return label;
      } else if (informe.mes == "11") {
        let label = "Noviembre";
        return label;
      } else {
        let label = "Diciembre";
        return label;
      }
    } else {
      return informe.nombre;
    }
  }
}
